import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AzureAuthService {

  baseUrl = environment.baseUrl;

  constructor(private http: HttpClient) { }

  getRequestInfos(): Observable<any> {
    const url = `${this.baseUrl}sso-request-infos?token=${this.getToken()}&user=${this.getUser()}`;
    return this.http.get<any>(url)
  }

  loginService(): void {
    window.location.href = `${this.baseUrl}auth/azure`;
  }

  saveToken(token: string): void {
    localStorage.setItem('token', token);
  }

  saveUser(user: string): void {
    localStorage.setItem('usuarioId', user);
  }

  savePermissions(permissions: string): void {
    localStorage.setItem('permissoes', permissions);
  }

  saveClientes(clientes: string): void {
    localStorage.setItem('clientes', clientes);
  }

  saveUsername(username: string): void {
    localStorage.setItem('usuario', username);
  }

  getToken(): string | null {
    return localStorage.getItem('token');
  }

  getUser(): string | null {
    return localStorage.getItem('usuarioId');
  }

  getUsername(): string | null {
    return localStorage.getItem('usuario');
  }

  getClientId(): string | null {
    return localStorage.getItem('clientes');
  }

  getPermissions(): string | null {
    return localStorage.getItem('permissoes');
  }
}
